'use client'

import { ToastProvider } from '@korvo/core/components/shared/Toast/ToastProvider'
import { type ReactNode } from 'react'

export function DefaultToastProvider({ children }: { children: ReactNode }) {
  return <ToastProvider>{children}</ToastProvider>
}


